import { useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Button } from "@mui/material";
import ConfirmDeleteModal from "../ConfirmDeleteModal";
import {
  cancelSubscription,
  resumeSubscription,
} from "../../redux/asyncThunk/userActions";
import {
  formatBusinessPlanLabel,
  formatSubscriptionExpiry,
  getSubscriptionRenewalStatusText,
  isSubscriptionCancelled,
  canManageSubscriptionRenewal,
} from "../../utils/userProfile";

export default function ProfileSubscriptionPanel({
  userId,
  businessSubscription,
}) {
  const dispatch = useDispatch();
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const canManage = canManageSubscriptionRenewal(businessSubscription);
  const cancelled = isSubscriptionCancelled(businessSubscription);
  const planLabel = formatBusinessPlanLabel(businessSubscription);
  const expiryLabel = formatSubscriptionExpiry(businessSubscription);
  const renewalStatus = getSubscriptionRenewalStatusText(businessSubscription);

  if (!canManage && !expiryLabel) {
    return (
      <section className="app-profile-card app-profile-card--subscription">
        <h3 className="app-profile-card__title">Подписка</h3>
        <p className="app-profile-muted app-profile-muted--compact">
          Подписка не подключена.{" "}
          <Link to="/main/price" className="app-profile-inline-link">
            Выбрать тариф
          </Link>
        </p>
      </section>
    );
  }

  const handleCancel = async () => {
    setIsSubmitting(true);

    try {
      await dispatch(cancelSubscription({ userId })).unwrap();
      setConfirmOpen(false);
    } catch {
      // сообщение уходит в redux messages
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleResume = async () => {
    setIsSubmitting(true);

    try {
      await dispatch(resumeSubscription({ userId })).unwrap();
    } catch {
      // сообщение уходит в redux messages
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="app-profile-card app-profile-card--subscription">
      <h3 className="app-profile-card__title">Подписка</h3>

      <div className="app-profile-subscription">
        <div className="app-profile-subscription__plan">{planLabel}</div>
        {renewalStatus ? (
          <p
            className={`app-profile-subscription__status${
              cancelled ? " app-profile-subscription__status--cancelled" : ""
            }`}
          >
            {renewalStatus}
          </p>
        ) : null}

        {canManage ? (
          <div className="app-profile-subscription__actions">
            {cancelled ? (
              <Button
                size="small"
                variant="outlined"
                disabled={isSubmitting}
                onClick={handleResume}
                sx={{ textTransform: "none", fontWeight: 600 }}
              >
                Включить автопродление
              </Button>
            ) : (
              <Button
                size="small"
                variant="outlined"
                color="error"
                disabled={isSubmitting}
                onClick={() => setConfirmOpen(true)}
                sx={{ textTransform: "none", fontWeight: 600 }}
              >
                Отменить автопродление
              </Button>
            )}
            <Link to="/main/price" className="app-profile-inline-link">
              Тарифы
            </Link>
          </div>
        ) : null}
      </div>

      <ConfirmDeleteModal
        open={confirmOpen}
        title="Отменить автопродление?"
        message={`Доступ сохранится до ${expiryLabel ?? "конца оплаченного периода"}.`}
        detail="Со следующего периода мы не будем списывать оплату. Вы сможете снова включить автопродление или оплатить подписку вручную."
        confirmLabel="Отменить автопродление"
        cancelLabel="Оставить"
        onClose={() => setConfirmOpen(false)}
        onConfirm={handleCancel}
      />
    </section>
  );
}
